import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Orders/Items'

export default createChildListViewContainer()(Component)
